import moment from 'moment';
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import GoKids from '../../services/GoKids';
import { Button } from 'reactstrap';
import PageTitle from '../../components/PageTitle';
import FormItem from '../../components/FormItem';
import Input from '../../components/Input';
import { setFieldValueGen } from '../../helpers/utils';

class FamilyRequestPage extends PureComponent {
  constructor(props) {
    super(props);
    this.setFieldValue = setFieldValueGen(this);
    this.state = { request: null, template: { isRead: false } };
  }

  async componentDidMount() {
    const requestId = this.props.match.params.id;
    const request = await GoKids.getFamilyRequest(requestId);
    this.setState({ request, template: { isRead: request.isRead } });
  }

  toggleRead = async (name, value) => {
    this.setFieldValue(name, value);
    const requestId = this.props.match.params.id;
    await GoKids.updateFamilyRequest(requestId, { isRead: value });
  };

  archive = async () => {
    this.setState({ isSubmitting: true });
    const requestId = this.props.match.params.id;
    const request = await GoKids.updateFamilyRequest(requestId, { deletedAt: 'now' });
    this.setState({ request, isSubmitting: false });
  };

  render() {
    const { request, template } = this.state;
    return (
      <Fragment>
        <PageTitle title={request ? request.name : 'carregando...'} />

        <div className="card card-form" style={styles.content}>
          <h4 className="form-subheader">Solicitação</h4>
          {!!request && <RequestData request={request} template={template} onChangeRead={this.toggleRead} />}

          {!!request && (
            <Fragment>
              <h4 className="form-subheader">Mais opções</h4>
              <FormItem label=" " className="content-info">
                {request.deletedAt ? (
                  <p className="text-danger">Solicitação arquivada {moment(request.deletedAt).fromNow()}</p>
                ) : (
                  <Button
                    type="button"
                    onClick={this.archive}
                    disabled={this.state.isSubmitting}
                    color="danger"
                    type="submit"
                  >
                    Arquivar solicitação
                  </Button>
                )}
              </FormItem>
            </Fragment>
          )}
        </div>
      </Fragment>
    );
  }
}

const RequestData = ({ request, template, onChangeRead }) => (
  <Fragment>
    <FormItem label="Nome:" className="content-info">
      {request.name}
    </FormItem>
    <FormItem label="E-mail:" className="content-info">
      <a target="_blank" href={`mailto:${request.email}`}>
        {request.email}
      </a>
    </FormItem>
    <FormItem label="Telefone:" className="content-info">
      {request.phoneNumber}
    </FormItem>
    <FormItem label="CEP:" className="content-info">
      <a target="_blank" href={`https://www.google.com/maps?q=${request.zipcode}`}>
        {request.zipcode}
      </a>
    </FormItem>
    <FormItem label="Cidade:" className="content-info">
      {request.city}/{request.state}
    </FormItem>
    <FormItem label=" " className="mt-3">
      <label className="form-check">
        <Input
          type="checkbox"
          className="form-check-input"
          name="isRead"
          checked={!!template.isRead}
          onChange={onChangeRead}
        />
        Marcar como visualizado
      </label>
    </FormItem>
    <h4 className="form-subheader">Mensagem</h4>
    <FormItem label="" className="content-info">
      {request.message}
    </FormItem>
  </Fragment>
);

const styles = {
  content: { paddingBottom: 24 },
  message: { whiteSpace: 'pre-line' }
};

export default FamilyRequestPage;



// WEBPACK FOOTER //
// ./src/screens/family/FamilyRequestPage.js